import {Component, OnInit} from '@angular/core';
import {UsuarioServices} from '../../CoreModule/services/usuario.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {SemanaServices} from '../services/semana.services';
import {SemanaModel} from '../models/semana.model';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoSemanaModel} from '../models/empleado.semana.model';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'reportes',
  templateUrl: './reportes.template.html'
})
export class ReportesComponent implements OnInit {

  tiendas: TiendaEntity[] = [];
  ano: number = 2019;
  semSelect = 14;

  tiendaSelect: string = '';

  cantidadVentas: number = 0;

  semana: SemanaModel;

  lstEmpleados: EmpleadoModel[] = [];
  lstMallas: EmpleadoSemanaModel[] = [];

  data: any = {};


  view: any[] = [900, 600];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Ventas';
  showYAxisLabel = true;
  yAxisLabel = 'En Pesos';
  timeline = true;
  consultando = 0;

  dataEmpleados:any[] = [];

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  constructor(private us: UsuarioServices, private spinner: NgxSpinnerService, private ts: TiendaServices, private ss: SemanaServices, private es: EmpleadoServices) {

  }

  cambioTienda(valor) {
    console.log(valor.target.value);
    this.consultarDatos(valor.target.value);
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      this.spinner.hide();
      console.log(d.data.tiendas);
      this.tiendas = d.data.tiendas;

      // this.consultarDatos(this.tiendas[0]);

    });
  }

  consultarDatos(tienda: any) {
    this.cantidadVentas = 0;
    this.spinner.show();
    this.consultando = 1;
    this.lstEmpleados = [];
    this.dataEmpleados = [];

    let se = this.tiendas.find((t) => {
      return t.idDB == tienda;
    });

    if (se)
      this.tiendaSelect = se.nombre;

    this.ss.devolverInfoTienda(`${this.ano}-${+this.semSelect + 1}`, tienda, this.ano, this.semSelect).subscribe(d => {
      console.log(d.data.ventas);

      for (let v of d.data.ventas) {
        this.cantidadVentas += v.cantidad;
      }
      this.semana = SemanaModel.CrearSemana(d.data.semana);


      this.data = [
        {
          'name': 'Meta',
          'value': this.semana.ventasSem
        },
        {
          'name': 'Minimo',
          'value': this.semana.ventasSem * .90
        },
        {
          'name': 'Ventas Actuales',
          'value': this.cantidadVentas
        }
      ];

      this.es.devolverEmpleadoTienda(tienda).subscribe((d2: any) => {
        let consultas: any[] = [];
        for (let e of d2.data.empleadoTienda) {
          let emple = new EmpleadoModel();
          emple.agregarDatos(e, this.semana);
          let v = d.data.ventas.filter(_v => {
            return _v.vendedor == emple.id;
          });

          for (let _v of v) {
            emple.agregarVenta(_v);
          }

          this.lstEmpleados.push(emple);
          // la consulta debe agregar la tienda que esta consultando
          consultas.push(this.es.devolverSemanaEmpleado(emple.id, this.semana.semana));

        }

        if(consultas.length == 0) {
          this.spinner.hide();
        }

        forkJoin(consultas).subscribe((d3:any)=>{
          for(let es of d3){
            if(es.data.empleadoSemana != null) {
              let empleSem = EmpleadoSemanaModel.CrearEmpleadoSemana(es.data.empleadoSemana);
              let emple = this.lstEmpleados.find(e=>e.id == empleSem.empleado);
              emple.mallaEmple = empleSem;
              emple.calcularIndicadores(empleSem);
              this.dataEmpleados.push(emple.dataGraficas);
              if (!this.lstMallas.find(me => me.id == emple.id)) {
                this.lstMallas.push(empleSem);
              }
            }
          }
          this.spinner.hide();
          console.log(this.dataEmpleados);
          this.consultando = 2;
        })
      });

      // this.spinner.hide();
      // this.consultando = 2;
    }, error1 => {
      this.spinner.hide();
    });
  }


}
